import Style from "./CreateCompanyStyle";
import api from "../../services/api";
import { useState } from "react";
import Spinner from "../../shared/Spinner/Spinner";
import PageTitle from "../../components/PageTitle";


export default function CreateCompany(props) {

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [successMessage, setSuccessMessage] = useState<string>();

  const [companyName, setCompanyName] = useState("");
  const [logoUrl, setLogoUrl] = useState("");

  async function OnSubmitCreateCompany() {
    try {
      setLoading(true);
      const data = {
        companyName,
        logoUrl
      }
      const request = api.post(`/companies`, data);
      const result = await request;
      console.debug("Resultado: ", result);
      setLoading(false);
      setSuccessMessage("Criou empresa com sucesso, id: " + result.data.id);
      setErrorMessage("");
    }
    catch (error: any) {
      console.error(error);
      setLoading(false);
      setErrorMessage(error?.response?.data?.message);
    }
  }

  return (
    <Style>
      <PageTitle title="Criar Empresa" />
      <div>
        <div>
          <button onClick={() => props.history.goBack()} className="btn btn-secondary">Voltar</button>
        </div>
        <Spinner spinning={loading} />
        {errorMessage && <p className="alert alert-error">Erro: {errorMessage}</p>}
        {successMessage && <p className="alert alert-info">{successMessage}</p>}
        <main>
          <div className="panel">
            <form className="main-form" onSubmit={(e) => { e.preventDefault(); OnSubmitCreateCompany(); }}>
              <h2>Criar empresa</h2>
              <div>
                <label>Nome da empresa:</label>
                <input

                  autoComplete="product-name"
                  disabled={loading}
                  value={companyName || ""}
                  onChange={e => setCompanyName(e.target.value)}
                />
              </div>
              <div>
                <label>Url da Logo:</label>
                <input

                  autoComplete="product-name"
                  disabled={loading}
                  value={logoUrl || ""}
                  onChange={e => setLogoUrl(e.target.value)}
                />
              </div>
              <button
                className="btn btn-success btn-lg mt-4"
                type="button"
                disabled={loading}
                onClick={e => {
                  e.preventDefault();
                  OnSubmitCreateCompany();
                }}>Adicionar
              </button>
            </form>
          </div>
        </main>
      </div>
    </Style >
  );
}